<div class="inactivity-sign-out-page-container container">

</div>
